module.exports = __webpack_public_path__ + "assets/0d438211fa4b472658e0d43606bb219d.mp3";